import { PromotionBanners } from "@/components/homepage/PromotionBanners";
import { Tournaments } from "@/pages/Tournaments";
import { useFirstVisitStore } from "@/store";
import { useAuthStore } from "@/store/auth.store";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NewUserModals } from "./NewUserModals";

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const isLoginRecent = (): boolean => {
  const stored = localStorage.getItem("loginAt");
  if (!stored) return false;
  try {
    const { loginAt } = JSON.parse(stored);
    if (!loginAt) return false;
    const loginTime = new Date(loginAt).getTime();
    return Date.now() - loginTime < ONE_WEEK_MS;
  } catch {
    return false;
  }
};

export const HomePage = () => {
  const isFirstVisit = useFirstVisitStore((state) => state.isFirstVisit);
  const setIsFirstVisit = useFirstVisitStore((state) => state.setIsFirstVisit);
  const authState = useAuthStore((state) => state.authState);
  const navigate = useNavigate();
  const isNewUser = useAuthStore((state) => state.isNewUser);
  const setIsNewUser = useAuthStore((state) => state.setIsNewUser);
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (!isLoginRecent() && isFirstVisit && authState === "unauthenticated") {
      setIsFirstVisit(false);
      navigate("/top");
    }
  }, [isFirstVisit, navigate, authState, setIsFirstVisit]);

  return (
    <div className="w-full">
      <PromotionBanners />
      <Tournaments />
      {isNewUser && <NewUserModals setIsNewUser={setIsNewUser} userFreePoints={user?.freePoints || "0"} />}
    </div>
  );
};
